import React from "react";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import "./FloatingLabelDatePicker.css";

interface FloatingLabelDatePickerProps {
  onChange: (date: Dayjs) => void;
  defaultValue: string; // ISO string format
  fieldType?: "effective" | "expiration";
  minDate?: Dayjs;
  enableCreate: boolean;
}

const FloatingLabelDatePicker: React.FC<FloatingLabelDatePickerProps> = ({
  onChange,
  defaultValue,
  fieldType,
  minDate,
  enableCreate,
}) => {
  const placeholder = `Select ${
    fieldType === "effective" ? "Effective" : "Expiration"
  } Date`;
  const dateFormat = "YYYY/MM/DD";

  const getDefaultValue = (): Dayjs | null => {
    if (!defaultValue || enableCreate) return null;

    try {
      // Parse the ISO string to dayjs object
      const parsedDate = dayjs(defaultValue);
      if (parsedDate.isValid()) {
        return parsedDate;
      }
    } catch (error) {
      console.error("Error parsing date:", error);
    }
    return null;
  };

  // Function to disable dates before today
  const disableInvalidDates = (current: Dayjs) => {
    if (fieldType === "effective") {
      return current && current < dayjs().startOf("day");
    } else if (fieldType === "expiration" && minDate) {
      return current && current <= minDate.startOf("day");
    }
    return false;
  };

  // Handle internal date change before passing to parent
  const handleDateChange = (date: Dayjs | null) => {
    if (date) {
      const currentDateTime = dayjs()
        .set("year", date.year())
        .set("month", date.month())
        .set("date", date.date())
        .set("hour", date.hour())
        .set("minute", date.minute())
        .set("second", date.second());
      onChange(date);
    } else {
      onChange(null as any);
    }
  };

  return (
    <div className="floating-datepicker-container">
      <DatePicker
        onChange={handleDateChange}
        value={enableCreate ? undefined : getDefaultValue()}
        placeholder={placeholder}
        format={dateFormat}
        disabledDate={disableInvalidDates}
      />
    </div>
  );
};

export default FloatingLabelDatePicker;

// import React, { useState } from 'react';
// import { format, parseISO } from 'date-fns';

// const FloatingLabelDatePicker = () => {
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [localTime, setLocalTime] = useState(format(new Date(), 'yyyy-MM-dd\'T\'HH:mm'));
//   const [utcTime, setUtcTime] = useState(new Date().toUTCString());

//   const handleDateChange = (e : any) => {
//     const parsedDate = parseISO(e.target.value);
//     setSelectedDate(parsedDate);
//     setLocalTime(format(parsedDate, 'yyyy-MM-dd\'T\'HH:mm'));
//     setUtcTime(parsedDate.toUTCString());
//   };

//   const handleTimeChange = (e : any) => {
//     const newLocalDateTime = parseISO(e.target.value);
//     setSelectedDate(newLocalDateTime);
//     setLocalTime(format(newLocalDateTime, 'yyyy-MM-dd\'T\'HH:mm'));
//     setUtcTime(newLocalDateTime.toUTCString());
//   };

//   return (
//     <div className="max-w-md mx-auto p-6 bg-white shadow-md rounded-lg">

//       <div className="mb-4">
//         <input
//           type="datetime-local"
//           value={localTime}
//           onChange={handleTimeChange}
//           className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//         />
//       </div>

//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700">
//           UTC Time
//         </label>
//         <input
//           type="text"
//           value={utcTime}
//           readOnly
//           className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 bg-gray-100"
//         />
//       </div>

//       <div>
//         <h3 className="text-lg font-semibold mb-2">Current Timezone Details</h3>
//         <p className="text-sm">
//           Local Timezone: {Intl.DateTimeFormat().resolvedOptions().timeZone}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default FloatingLabelDatePicker;
